import React from 'react';
import { Logo } from './Logo';

export const Footer: React.FC = () => (
  <footer className="bg-surface border-t border-hairline mt-auto">
    <div className="shell py-7 flex flex-col sm:flex-row items-center justify-between gap-3">
      <div className="flex items-center gap-3">
        <Logo size={22} showWord={false} />
        <span className="text-sub text-sm">Jouw volgende stap in digitaal en AI</span>
      </div>
      <span className="text-muted text-xs">Een product van vrules.nl</span>
    </div>
  </footer>
);
